module.exports = __webpack_public_path__ + "img/p5.3917c8d6.png";